import { Box, Heading } from '@chakra-ui/react';

type ILeftOptions = React.ReactNode;

type ICenterOptions = React.ReactNode | string;

interface IProps {
	left: ILeftOptions;
	center: ICenterOptions;
	right: React.ReactNode;
}

export default function HeaderTemplate(props: IProps) {
	return (
		<Box pt={4} pb={4} as="header" display="grid" gridTemplateColumns="1fr 1fr 1fr" alignItems="center">
			<Box>{props.left}</Box>
			{typeof props.center === 'string' ? (
				<Heading overflow="hidden" size="sm" textAlign="center" textOverflow="ellipsis" whiteSpace="nowrap">
					{props.center}
				</Heading>
			) : (
				<Box>{props.center}</Box>
			)}
			<Box display="flex" justifyContent="flex-end">
				{props.right}
			</Box>
		</Box>
	);
}
